<template>
  <el-card>
    <h3 slot="header">
      <!--<el-button type="default" size="mini">Redeem credit</el-button>-->
      {{ period }}
    </h3>

    <strong>Estimated costs for this billing period :</strong>
    <div v-if="projectCosts && permission('owner')" class="current-cost">
      This is the current costs for your usage <strong>{{ $root.currency.symbol }}{{ accountCosts }}</strong>
    </div>

    <div v-if="projectCosts" class="current-project">
      Current costs for <span>{{ project.name }}</span> project <strong>{{ $root.currency.symbol }}{{ currentCosts }}</strong>
    </div>

    <div v-if="customer" class="current-balance">
      Credit Balance <strong>{{ $root.currency.symbol }}{{ balance }}</strong>
    </div>

    <div class="current-product">
      <el-divider />
      <el-button type="primary" size="mini" @click="$emit('change-product', true)">Change Plan</el-button>
      <ProductDescription :client="client" :show-list="false" />
    </div>
  </el-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment-timezone'
import ProductDescription from '../Account/ProductDescription'

export default {
  props: {
    customer: Object
  },
  components: {
    ProductDescription
  },
  data () {
    return {
      period: moment().format('MMMM [1] [-] DD, YYYY')
    }
  },
  computed: {
    balance () {
      return parseInt((this.customer || {}).balance).toString().padStart(3, 0).replace(/([0-9]{2})$/, '.$1')
    },
    projectCosts () {
      return this.costs[this.project.id]
    },
    currentCosts () {
      return this.costs[this.project.id].total.toString().padStart(3, 0).replace(/([0-9]{2})$/, '.$1')
    },
    accountCosts () {
      const total = Object.keys(this.costs).reduce((sum, key) => sum + parseInt(this.costs[key].total || 0), 0)
      return total.toString().padStart(3, 0).replace(/([0-9]{2})$/, '.$1')
    },
    ...mapState(['client', 'project', 'costs']),
    ...mapGetters(['permission'])
  }
}
</script>

<style lang="scss" scoped>
  @import "../../theme";

  h3 {
    margin: 0;

    .el-button {
      float: right;
    }
  }

  .current-cost {
    line-height: 50px;

    strong {
      float: right;
      font-size: 30px;
    }
  }

  .current-balance, .current-project {
    line-height: 30px;

    strong {
      float: right;
      font-size: 14px;
    }

    &.current-project {
      strong, span {
        color: $--color-primary;
      }
    }
  }

  .current-product {
    line-height: 30px;
    margin-top: 10px;
    margin-bottom: -20px;

    .el-button {
      float: right;
      margin: 0 0 30px 20px;
    }
  }
</style>
